import { Link, useLocation, useNavigate } from "react-router-dom";
import Back from "./../../../../assets/icons/back.svg";
import AdsCheckoutCard from "../../../../components/ads/adsCheckoutCard";
import AddCard from "../../../../components/common/addcard";
import Checkbox from "../../../../components/common/checkBox";
import Button from "../../../../components/common/button";
import Delete from "../../../../assets/icons/delete.svg";
import GreenCheck from "../../../../assets/icons/greenCheck.svg";
import { Card, Form, Input, message } from "antd";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import {
  deleteCard,
  fetchCardList,
} from "../../../../store/slices/paymentSlice";
import { useDispatch, useSelector } from "react-redux";
import VisaCard from "../../../../components/common/visaCard";
import MasterCard from "../../../../components/common/masterCard";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { adsPayment, adsTypes } from "../../../../api/ads";
import InvitationSentCard from "../../../../components/common/invitationSentCard";
const AdsCheckout = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [selectedDiv, setSelectedDiv] = useState(null);
  const [showCheckBox, setShowCheckBox] = useState(false);
  const [adsType, setAdsType] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showSentCard, setShowSentCard] = useState(false);
  const location = useLocation();
  const { adsData } = location.state || {};
  const cardData = useSelector((state) => state?.discount?.res);
  const deletedCard = useSelector((state) => state?.discount?.delete);
  const userData = useSelector((state) => state?.user?.response);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const divCardHandler = (cardClick) => {
    setSelectedCard(cardClick);
    setSelectedDiv(cardClick?.id);
    setShowForm(false);
    setShowCheckBox(true);
  };
  const typeName = adsType?.find((item) => item?._id === adsData?.type);
  const addNewAd = async () => {
    setLoader(true);
    const price = +(adsData?.numberOfDays * 10);
    const payload = {
      _id: adsData?._id,
      paymentId: selectedCard?.id,
      stripeCustomerId: userData?.stripeCustomerId,
      price: price,
    };
    const res = await adsPayment(payload);
    if (res) {
      message.success("Your advertisement is Live");
      setShowSentCard(true);
      navigate("/main/ads");
    }
    setLoader(false);
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };
  const YesClickHandler = async () => {
    setIsModalOpen(false);
    try {
      dispatch(deleteCard(selectedCard?.id));
    } catch (error) {}
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleForm = () => {
    setShowForm(true);
    setShowCheckBox(false);
  };
  const onFinish = () => {};
  const cardClickHandler = async (card) => {
    setLoader(true);
    setSelectedCard(card);
    showModal();
    setLoader(false);
  };
  const [form] = Form.useForm();
  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchCardList());
      const res = await adsTypes();
      setAdsType(res);
    };
    fetchData();
  }, [deletedCard, dispatch]);

  return (
    <>
      {showSentCard ? (
        <div className="flex pt-3 px-3">
          <InvitationSentCard
            linkTo={"/main/ads"}
            text={"Payment Completed"}
            img={GreenCheck}
          />
        </div>
      ) : (
        <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
          <div className="flex pt-3 pl-3">
            <Link to="/main/ads/pending-ads">
              <div className="flex items-center">
                <img src={Back} alt="Edit Icon" className="mr-1" />
                <span className="text-lg font-bold text-black ml-1">
                  Checkout
                </span>
              </div>
            </Link>
          </div>
          <AdsCheckoutCard data={adsData} name={typeName?.name} />
          <Card className="m-2 shadow-md">
            <p className="ml-2 text-primaryPurple font-bold text-lg shado flex sm:justify-start justify-center">
              Select Payment Method
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center 2xl:grid-cols-5 sm:justify-start justify-center sm:items-start sm:ml-2 space-y-1 mb-1 sm:space-y-1">
              {cardData?.map((card) => (
                <div
                  key={card?.id}
                  className={`first:mt-1 hover:cursor-pointer w-24.6 relative group ${
                    selectedDiv === card?.id
                      ? "outline outline-offset-2 outline-2 rounded-sm"
                      : ""
                  } `}
                  onClick={() => divCardHandler(card)}
                >
                  {card?.brand === "visa" ? (
                    <VisaCard
                      last4={card?.last4}
                      date={
                        card?.expiryMonth +
                        "/" +
                        card?.expiryYear.toString().slice(-2)
                      }
                    />
                  ) : (
                    <MasterCard
                      last4={card?.last4}
                      date={
                        card?.expiryMonth +
                        "/" +
                        card?.expiryYear.toString().slice(-2)
                      }
                    />
                  )}
                  <div
                    className="absolute top-0 right-0 border-none p-0 opacity-0 group-hover:opacity-100 transition-opacity"
                    onClick={() => {
                      cardClickHandler(card);
                    }}
                    style={{ right: "-10px", top: "-10px", zIndex: 10 }}
                  >
                    <img src={Delete} alt="Delete Icon" className="w-4" />
                  </div>
                </div>
              ))}

              {/* <div onClick={handleForm}>
                <AddCard title={"Add Card"} />
              </div> */}
            </div>

            <div>
              {showCheckBox && (
                <div className="">
                  <div className="ml-2 font-medium">
                    <Checkbox
                      description="Save Card Details"
                      onChecked={(value) => {}}
                    />
                  </div>
                  <div className="flex justify-end space-x-4 ml-1 mr-2 mb-2">
                    <Button
                      title="Pay Now"
                      loading={loader}
                      onClick={addNewAd}
                      className="bg-primaryPurple w-15.8 h-3.4"
                    />
                  </div>
                </div>
              )}

              {showForm && (
                <div className="">
                  <Form onFinish={onFinish} form={form}>
                    <div className="xl:grid xl:grid-cols-4 sm:grid sm:grid-cols-1 gap-3 md:grid md:grid-cols-2 mt-2 ml-2 mr-2">
                      <Form.Item
                        name="holderName"
                        rules={[
                          {
                            required: true,
                            message: "Holder Name is required",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Holder Name"
                          className="bg-inputFieldGrey mr-2 w-full h-5.4 placeholder-placeHolderGrey"
                        />
                      </Form.Item>
                      <Form.Item
                        name="cardNumber"
                        className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center"
                      >
                        <div className="ml-1">
                          <CardNumberElement />
                        </div>
                      </Form.Item>
                      <Form.Item
                        name="cardExpiry"
                        className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center"
                      >
                        <div className="ml-1 text-primaryBlue">
                          <CardExpiryElement />
                        </div>
                      </Form.Item>
                      <Form.Item
                        name="cardCVV"
                        className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center"
                      >
                        <div className="ml-1">
                          <CardCvcElement />
                        </div>
                      </Form.Item>
                    </div>

                    <div className="flex justify-end space-x-4 ml-1 mr-2 mb-2">
                      <Button
                        title="Pay Now"
                        className="bg-primaryPurple w-15.8 h-3.4"
                        loading={loader}
                        htmlType="submit"
                      />
                    </div>
                  </Form>
                </div>
              )}
            </div>
          </Card>
          {isModalOpen && (
            <DeleteMemberModal
              title="Delete Card"
              text="Are you sure you want to delete card?"
              onCancel={hideModal}
              onOk={YesClickHandler}
            />
          )}
        </div>
      )}
    </>
  );
};
export default AdsCheckout;
